import React, { useState } from 'react'
import { IconButton, AvatarImage, Picture } from 'components'
import { icons } from 'assets'
import styles from './AddedItem.module.scss'
import { getMainImageSrcForObj, getObjId } from 'utilities'

interface Props {
  item: any;
  onRemove?: (id: number | string) => void;
  type?: 'person' | 'product';
}

const AddedItem = (props: Props) => {
  const [hovered, setHovered] = useState(false)
  const { item, onRemove, type = 'person' } = props

  return (
    <div
      className={styles.addedItem}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {
        type === 'person'
          ? (
            <AvatarImage
              size={70}
              src={getMainImageSrcForObj(item)}
              alt={item.name}
            />
          )
          : (
            <Picture
              size={70}
              src={getMainImageSrcForObj(item)}
              alt={item.name}
            />
          )
      }

      <p>{item.name}</p>

      {onRemove &&
        <IconButton
          icon={icons.closeX}
          className={
            `${styles.removePersonBttn} ${hovered ? styles.visibleBttn : ''}`
          }
          onClick={() => onRemove(getObjId(item))}
        />}
    </div>
  )
}

export default AddedItem
